<template>
  <div class="ly_match_detail">
    <div class="hd">
      <h2 class="tit">예측배틀</h2>
      <a class="btn_close" href="javascript:;" @click="closeDetail">닫기</a>
    </div>
    <div class="bd">
      <div class="game_list">
        <div class="item" :class="sportsClassItem.class">
          <!--
          <div class="event">{{ sportsClassItem.text }} - {{ detail.lnm }}</div>
          -->
          <div class="event">{{ detail.lnm }}</div>
          <div class="time">{{ detail.matchdate }}</div>
          <div class="type pre_match">{{ statusItem }}</div>
          <div class="team_area">
            <span class="team left">{{ detail.hTeamNm }}</span>
            <span class="vs">VS</span>
            <span class="team right">{{ detail.aTeamNm }}</span>
          </div>

          <matchDetailItem :detail="detail" :type="type"/>

          <div class="info">
            <dl>
              <dt>설정 골드</dt>
              <dd>{{ numberToString(detail.gold) }}</dd>
            </dl>
            <dl>
              <dt>승리시 총 획득 골드</dt>
              <dd class="win">{{ numberToString(winPrice) }}</dd>
            </dl>
            <dl>
              <dt>패배시 총 차감 골드</dt>
              <dd class="lose">{{ numberToString(lossPrice) }}</dd>
            </dl>
          </div>
          <a class="_btn" href="javascript:;" @click="joinMath">도전하기</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import matchDetailItem from '@/components/match/match-detail-item'

  export default {
    name: "match-detail",
    components: {
      matchDetailItem
    },
    props:[
      'type'
    ],
    data() {
      return {
        detail:{},
      }
    },
    methods: {
      closeDetail() {
        this.$store.dispatch('match/closeDetail');
      },
      async getDetail() {
        let res = await this._get("/v1/match/betMatchDetail", {
          id : this.item.id
        });

        this.detail = res.data
      },
      async joinMath() {
        if (confirm('도전 하시겠습니까?') === false) {
          return false;
        }

        let res = await this._post("/v1/match/join", {
          id : this.detail.id
        });

        if (res.data.message) {
          alert(res.data.message);
          this.$store.dispatch('match/clearAllPopup');
        }

        if (res.data.error) {
          return ;
        }

        conm.topuserinfo()
        if (this.$route.query.type) {
          this.$eventBus.$emit("matchList");
        } else {
          const routeQuery = {
            path: this.$route.path,
            query: {
              type : 'my',
              gameType : this.item.game_type,
              sportsId : this.detail.sportsid
            }
          }

          this.$router.push(routeQuery)
        }

      },
    },
    created() {
      this.getDetail();
    },
    computed: {
      item() {
        return this.$store.getters['match/detailItem'];
      },

      winPrice() {
        let price = this.detail.owner_price;
        if (!this.detail.isOwner) {
          price = this.detail.guest_price;
        }

        return Math.round(this.detail.gold * price);
      },
      lossPrice() {
        let price = this.detail.guest_price;
        if (!this.detail.isOwner) {
          price = this.detail.owner_price;
        }
        return Math.round((this.detail.gold * price) * -1)
      },
      statusItem() {
        return this.statusList[this.item.game_type]
      },
      sportsClassItem() {
        const index = this._.findIndex(this.sportsCategory, {'id': this.item.sportsid});
        return this.sportsCategory[index]
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/match/match-detail.vue